export default __webpack_public_path__ + "static/media/YE.997d98d2.ico";